export var StrategyOptions = /*#__PURE__*/ function(StrategyOptions) {
    StrategyOptions["LoadBalanced"] = "LOAD_BALANCED";
    StrategyOptions["MaximumMargin"] = "MAXIMUM_MARGIN";
    StrategyOptions["Manual"] = "MANUAL";
    return StrategyOptions;
}({});
export var StepsId = /*#__PURE__*/ function(StepsId) {
    StepsId[StepsId["SelectProject"] = 0] = "SelectProject";
    StepsId[StepsId["LoadResources"] = 1] = "LoadResources";
    StepsId[StepsId["PlanTeam"] = 2] = "PlanTeam";
    StepsId[StepsId["OptimizeFinancial"] = 3] = "OptimizeFinancial";
    StepsId[StepsId["Allocate"] = 4] = "Allocate";
    return StepsId;
}({});
